import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import GuidePage from './components/GuidePage.jsx';
import WebinarPage from './components/WebinarPage.jsx';
import WebinarPage2 from './components/WebinarPage2.jsx';
import WebinarThankYouPage from './components/WebinarThankYouPage.jsx';
import WebinarCalendarPage from './components/WebinarCalendarPage.jsx';
import WebinarLivePage from './components/WebinarLivePage.jsx';
import WebinarTerminPage from './components/WebinarTerminPage.jsx';
import WebinarReplayPage from './components/WebinarReplayPage.jsx';
import { initCalendlyListener } from './lib/tracking.js';
import { captureLeadSource } from './lib/lead-source.js';
import { captureFbTracking } from './lib/fb-tracking.js';

// Listener for Calendly booking confirmations — must run on EVERY route
// (the popup widget can be opened from anywhere) and BEFORE React mounts,
// because the listener is global and the booking can complete any time.
initCalendlyListener();

// Persist UTM-style URL params so the ActiveCampaign hidden field can be
// filled later (when the registration modal mounts and the AC embed renders).
captureLeadSource();

// Capture Meta CAPI attribution signals (fbclid → reconstructed fbc, etc.) at
// boot so they survive to the registration form and get written into the AC
// "tracking" field — see src/lib/fb-tracking.js for the full rationale.
captureFbTracking();

// Self-hosted Montserrat (300, 400, 500, 600, 700, 800, 900)
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import '@fontsource/montserrat/900.css';

// Self-hosted Instrument Serif (regular + italic)
import '@fontsource/instrument-serif/400.css';
import '@fontsource/instrument-serif/400-italic.css';

// Self-hosted JetBrains Mono (regular + medium)
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import './styles.css';

// Tiny static router. Routing is decided once at boot:
//   /guide             → thank-you / PDF-redirect page (HubSpot form-success target)
//   /webinar           → standalone webinar funnel
//   /webinar2          → backup copy of the webinar funnel (pre-edit snapshot)
//   /webinar-thank-you → confirmation page (ActiveCampaign form-success target)
//   /webinar-calendar  → standalone add-to-calendar page (linked from reminder e-mails)
//   /live              → live-webinar landing / placeholder (referenced by calendar invites)
//   /termin            → Calendly Strategiegespräch booking (post-webinar / mid-broadcast CTA)
//   /replay            → Webinar-Aufzeichnung (Zoom-Embed) + /termin-CTA
//   *                  → main marketing app (App.jsx)
const path = window.location.pathname;
let Root = App;
if (/^\/guide\/?$/i.test(path)) Root = GuidePage;
else if (/^\/webinar\/?$/i.test(path)) Root = WebinarPage;
else if (/^\/webinar2\/?$/i.test(path)) Root = WebinarPage2;
else if (/^\/webinar-thank-you\/?$/i.test(path)) Root = WebinarThankYouPage;
else if (/^\/webinar-calendar\/?$/i.test(path)) Root = WebinarCalendarPage;
else if (/^\/live\/?$/i.test(path)) Root = WebinarLivePage;
else if (/^\/termin\/?$/i.test(path)) Root = WebinarTerminPage;
else if (/^\/replay\/?$/i.test(path)) Root = WebinarReplayPage;

ReactDOM.createRoot(document.getElementById('app')).render(<Root />);
